import styled, { css } from 'styled-components';
import { down } from 'styled-breakpoints';
import { Link } from 'react-router-dom';

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.375rem;
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;
  color: var(--colors-brand-primary);

  > h2 {
    font-size: 1rem;
    font-weight: 700;
    color: var(--colors-foreground-100);
  }
`;

export const ShowAllLink = styled(Link)`
  ${({ theme }) => css`
    font-size: 0.8125rem;
    color: ${theme.colors.brand.primary.default};
    font-weight: 600;
  `}
`;

export const Tier1Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.875rem;
  margin-bottom: 0.875rem;

  ${down('md')} {
    grid-template-columns: 1fr;
  }
`;

export const Tier2Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.875rem;

  ${down('md')} {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const SponsorCard = styled.div`
  ${({ theme }) => css`
    height: 7rem;
    border-radius: 0.875rem;
    background: ${theme.colors.background[100]};
    border: 1px solid ${theme.colors.background[40]};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
    }

    &:hover .logo-inner {
      filter: grayscale(0%);
    }

    > a {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }
  `}
`;

export const SponsorLogo = styled.div`
  filter: grayscale(30%);
  transition: filter 0.3s ease;

  > img {
    max-width: 11rem;
    max-height: 3.75rem;
    object-fit: contain;
  }
`;
